import styled from "styled-components";

import { ClickableToggleDisplay } from "../../../../../App/Common/Components/FormComponents";
import colors from "../../../../../styles/colors";

export const ClickableText = styled(ClickableToggleDisplay)`
  min-width: 60rem;
`;

export const AnswerBox = styled.div`
  align-items: center;
  background: ${colors.lightgrey};
  display: flex;
  height: 100%;
  margin: 1rem 2rem;
  min-height: 5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  width: auto;
`;

export const HoverableAnswerBox = styled(AnswerBox)`
  transition: background 0.125s ease;
  &:hover {
    background: ${colors.grey};
  }
`;

export const AnswerContent = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;
`;

export const HintBox = styled(AnswerBox)`
  background: ${colors.lightyellow};
  border-radius: 0.5rem;
  margin: 1rem 3rem;
`;
